import type { Components, Theme } from "@mui/material/styles";

export const MuiLinearProgress: Components<Theme>["MuiLinearProgress"] = {
  styleOverrides: {
    root: () => ({
      backgroundColor:
        "light-dark(var(--mui-palette-neutral-light), var(--mui-palette-neutral-dark))",
    }),
  },
};
